import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import axios from 'axios'
import VueAxios from 'vue-axios'
window.$ = window.jQuery = require('jquery');
import VueCountdown from '@chenfengyuan/vue-countdown';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'
import GiGridImages from '@chinhpd/vue3-grid-images';
import Toaster from "@meforma/vue-toaster";
import Vue3Autocounter from 'vue3-autocounter';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';


const app = createApp(App);
app.use(router)
app.use(VueAxios, axios)
app.use(moment)
app.use(Toaster)
app.component(VueCountdown.name, VueCountdown);
app.component('Datepicker', Datepicker);
app.component('GiGridImages', GiGridImages);
app.component('vue3-autocounter', Vue3Autocounter);
app.component(PulseLoader);


//app.config.globalProperties.backendUrl = 'http://localhost/asfBackend/api';
//app.config.globalProperties.backendImgUrl = 'http://localhost/asfBackend/public/images';
//app.config.globalProperties.backendFileUrl = 'http://localhost/asfBackend/public';

app.config.globalProperties.backendUrl = 'http://203.76.123.197/asfBackend/api';
app.config.globalProperties.backendImgUrl = 'http://203.76.123.197/asfBackend/public/images';
app.config.globalProperties.backendFileUrl = 'http://203.76.123.197/asfBackend/public';



app.config.globalProperties.$filters = {
    timeAgo(date) {
    return moment(date).fromNow()
    },
    timeRemain(){
        let start = Date.now(); 
        let end = moment("2022-11-28T00:01:00.000Z");
        let duration = moment.duration(end.diff(start));
        //let time = duration.asDays();
        return duration;
    },

    myDateFormate(date){
        return moment(date).format("DD MMM YYYY"); 
    },
    fullMonthDateFormate(date){
        return moment(date).format("DD MMMM YYYY"); 
    },
    str_limit(value, size) {
        if (!value) return '';
        value = value.toString();

        if (value.length <= size) {
            return value;
        }
        return value.substr(0, size) + '...';
    },
    
}
app.mount('#app')







